const DeleteIcon = () => {
  return (
    <svg
      className="flex shrink-0"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13"
        cy="13.0002"
        r="8.55927"
        transform="rotate(45 13 13.0002)"
        fill="white"
        stroke="black"
        strokeWidth="0.5"
      />
      <line
        x1="16.8467"
        y1="9.01662"
        x2="9.01646"
        y2="16.8469"
        stroke="black"
        strokeWidth="0.5"
      />
      <line
        x1="16.9834"
        y1="16.8477"
        x2="9.15314"
        y2="9.01744"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default DeleteIcon;
